<template>
  <div class="notice-list">
    <Card style="height: 240px;min-width:360px;">
        <p slot="title" style="line-height: 24px;"><Icon :type="icon" size="15"></Icon> {{type}} 
          <span class="search" v-if="type=='常见问答'">
            <Input style="width: 150px;margin-right: 10px" size="small" v-model="ser_data"></Input>
            <Button type="primary" size="small"  @click="getNoticeList">搜索</Button>
          </span>
          <span class="search" v-if="type=='操作指南'">
            <Checkbox v-model="isNotice">接收通知</Checkbox>
          </span>
        </p>
        <div v-if="type==='用户'">
          <div class="pending-items">
            <Content :style="{minHeight: '160px', background: '#fff'}">
              <div class="item">
                <span>所属区域：</span>
                <span style="padding-left:10px;">{{user.selectDistrict}}</span>
              </div>
              <div class="item">
                <span>角色信息：</span>
                <span class="role">
                  <i v-for="(role,index) in roles" :key="index">{{role}}</i>
                </span>
              </div>
            </Content>
          </div>
        </div>
        <div v-else>
          <div v-if="noticeList.length === 0" style="text-align: center;">
            暂无数据
          </div>
          <div v-else>
            <div class="notice-item">
              <div class="title header">标题</div>
              <!-- <div class="remark header">摘要</div> -->
              <div class="date header">发布时间</div>
            </div>
            <div class="notice-item detail-item" v-for="notice in noticeList" :key="notice.id" @click="showNotice(notice)">
              <div class="title" :title="notice.title">
                <Icon type="ios-flame" color="red" v-show="notice.isHot"></Icon>
                {{notice.title}}
              </div>
              <!-- <div class="remark" :title="notice.summary">{{notice.summary}}</div> -->
              <div class="date">{{notice.addDate | filterTime}}</div>
            </div>
            <Button size="small" style="position: absolute;right: 15px;bottom: 5px;" type="warning" @click="naviMore">
              查看更多
              <Icon type="android-arrow-forward"></Icon>
            </Button>
          </div>
        </div>
    </Card>
    <Modal
      v-model="noticeVisible" 
      class-name="notice-modal" 
      width="96%" 
      :mask-closable="false"
      :closable="!showNeverNotify">
      <h3 slot="header">
        <span>{{ noticeDetail.title }}</span>
        <span style="float:right;line-height:20px;" v-show="showNeverNotify">
          <Checkbox v-model="neverNotify" style="margin-right: 30px">不再提醒</Checkbox>
          <Icon type="close-round" @click="closePopNotice"></Icon>
        </span>
      </h3>
      <detail :data="noticeDetail" :fullList="fullList" @dataChange="(val)=>{noticeDetail=val}"></detail>
      <div slot="footer">
        <Button
          type="success" 
          size="small" 
          v-show="showNeverNotify && popNotice.length > 0" 
          @click="()=>{popNotice.shift();nextNotice()}">下一条</Button>
      </div>
    </Modal>
    <!-- 通知时间段选择 弹窗 -->
    <Modal v-model="noticeModal" title="通知时间" width="400" :mask-closable="false" @on-visible-change="(val)=>{if(!val){isNotice=val}}">
      <p>
        <span style="margin-right:10px">请选择接收通知时间段：</span>
        <TimePicker v-model="noticeTime" format="HH:mm" type="timerange" placement="bottom-end" style="width: 184px"></TimePicker>
      </p>
      <div slot="footer"><Button type="primary" @click="remindNotice">确定</Button></div>
    </Modal>
  </div>
</template>

<script>
import ajax from '@/lib/ajax'
import axios from 'axios'
import requestUrls from '@/lib/requestUrls'
import detail from "./detail"
import { setTimeout } from 'timers'
import Cookies from 'js-cookie'

var apiKey = '6dc99789-2448-4f11-9bfa-e6600366c6cb'
var siteId = '2139'
var channelId = '2140'

export default {
  name: 'noticeList',
  components:{detail},
  props: {
    type: {
      default:()=>{
        return '操作指南'
      }
    },
    icon:{
      default:()=>{
        return 'ios-bell'
      }
    }
  },
  data() {
    return {
      noticeList: [],
      noticeDetail: {
        title: '',
        content: ''
      },
      noticeVisible: false,
      ser_data: '',//搜索标题
      Loading: false,//表格loading
      fullList: [],
      isNotice: false,
      noticeModal: false,
      noticeTime: ['08:30', '17:30'],
      settingTime: [],
      popNotice: [],
      neverNotify: false,
      showNeverNotify: false,
      noremindArray: []
    }
  },
  mounted() {
    this.noremindArray = Cookies.getJSON(`${this.user.id}`) ? Cookies.getJSON(`${this.user.id}`) : []
    if (this.type === '操作指南') {
      this.getSettingTime()
    }
    this.getNoticeList()
    // 获取菜单列表
    axios.get(requestUrls.siteserverUrl + `/api/v1/stl/channels?apiKey=${apiKey}&siteId=2139&channelIndex=Abp`).then(
      rep => {
        let data = rep.data.value
        data.forEach((li,index) => {
          this.fullList.push({title: li.channelName})
          if (li.childrenCount == 0) {   // 无二级栏目
            axios.post(requestUrls.siteserverUrl + `/api/v1/contents?apiKey=${apiKey}`, {
              siteId: li.siteId,
              channelId: li.id,
              orders: 'addDate DESC'
            }).then(res => {
              this.detail = res.data.contents[0]
              this.$set(this.fullList[index],'children',res.data.contents)
            })
          } else {   // 二级栏目
            this.$set(this.fullList[index],'children',[])
            axios.get(requestUrls.siteserverUrl + `/api/v1/stl/channels?apiKey=${apiKey}&siteId=2139&channelIndex=${li.indexName}`).then(
              res => { 
                res.data.value.forEach((child,i) => {
                  this.fullList[index].children.push({title: child.channelName})
                  axios.post(requestUrls.siteserverUrl + `/api/v1/contents?apiKey=${apiKey}`, {
                    siteId: child.siteId,
                    channelId: child.id,
                    orders: 'addDate DESC'
                  }).then(res => {
                    this.$set(this.fullList[index].children[i],'children',res.data.contents)
                  })
                })
              }
            )
          }
        })
      }
    )
  },
  computed: {
    roles () {
      return this.$store.state.session.roleNames
    },
    user () {
      return this.$store.state.session.user
    }
  },
  watch: {
    isNotice(val) {
      if (val) {
        if (this.settingTime.length === 0) {
          this.noticeModal = val
        }
      } else {
        if (this.settingTime.length !== 0) {
          this.$Modal.confirm({
            title: '取消通知',
            content: '<p>确定取消接收通知吗？</p>',
            onOk: () => {
              this.settingTime.forEach(time => {
                ajax.delete('/api/services/app/AbpUserSettings/Delete?id=' + time.id).then(() => {
                  // 重新获取
                  this.getSettingTime()
                })
              })
              this.$Message.success('已取消接收通知')
            },
            onCancel: () => {
              this.isNotice = true
            }
          })
        }
      }
    }
  },
  methods: {
    // 公告轮播
    nextNotice() {
      if (this.popNotice.length !== 0) {
        this.showNotice(this.popNotice[0])
        // 记录已展示公告
        this.noremindArray.push({
          title: this.popNotice[0].title,
          deadline: this.popNotice[0].tags.split('/')[1]
        })
      } else if (this.showNeverNotify) {
        this.$Message.info('已经是最后一条啦！')
      }
    },
    closePopNotice() {
      if(this.popNotice.length > 0) {     // 公告未轮播完毕
        this.$Message.info('请点击右下角，查看下一条公告')
      } else {      // 公告轮播完毕 是否勾选不再提醒
        this.showNeverNotify = false
        Cookies.set('readed', this.user.id)  // 控制弹窗在登录期间只弹一次
        if (this.neverNotify) {
          // 获取最大日期
          let maxDate = new Date(this.noremindArray[0].deadline)
          for (let i = 0; i < this.noremindArray.length; i++) {
            if (maxDate < new Date(this.noremindArray[i].deadline)) {
              maxDate = new Date(this.noremindArray[i].deadline)
            }
          }
          Cookies.set(`${this.user.id}`, this.noremindArray, {expires: maxDate})
        }
        this.noticeVisible = false
      }
    },
    async getNoticeList() {
      switch(this.type){
        case '通知公告':
          siteId = '2139'
          channelId = '2150'
          break;
        case '常见问答':
          siteId = '2139'
          channelId = '2151'
          break;
        case '操作指南':
          siteId = '2139'
          channelId = '4348'
          break;
      }
      this.Loading= true
      let rep = await axios.post(requestUrls.siteserverUrl + `/api/v1/contents?apiKey=${apiKey}`, {
        siteId: siteId,
        channelId: channelId,
        orders: 'addDate DESC'
      })
      this.Loading = false
      let count = 0
      rep.data.contents.forEach((val,index)=>{
        let url = 'http://www.chinapsp.cn'
        let arr = val.content.match(/<img(.*?)src="(.*?)"(.*?)\/>/g)
        if(arr){
          arr.forEach(item => {
            val.content = val.content.replace(item,item.slice(0,10) + url + item.slice(10))
          })
        }
        rep.data.contents[index] = val
        // 按热度分类
        if (val.isHot) {
          this.noticeList.splice(count, 0, val)
          count++
        } else {
          this.noticeList.push(val)
        }
      })
      // 限制显示三条数据
      if (this.type !== '通知公告') {
        this.noticeList = this.noticeList.filter((item,index)=>{
          return index < 3
        })
      } else {
        let today = new Date()
        this.noticeList.forEach(li => {
          let date = li.tags.split('/')  // 通知公告 时间段
          let start = new Date(date[0])
          let end = new Date(date[1])
          if (today > start && today < end) {
            this.popNotice.push(li)
          }
        })
        // 已存在cookie的文档剔除
        this.noremindArray.forEach(item => {
          this.popNotice = this.popNotice.filter(notice => {
            return notice.title != item.title
          })
        })
      }
      if (this.type === '通知公告' && Cookies.get('readed') != this.user.id) {      // 判断用户是否已读(退出登录删除此cookie)
        setTimeout(() => {
          this.nextNotice()
          this.showNeverNotify = true
        }, 500)
      }
    },
    getSettingTime() {
      // 获取用户设置
      ajax.get('/api/services/app/AbpUserSettings/GetSettingListByType',{
        params: {
          type: 'noticeTime'
        }
      }).then(res => {
        // 用户是否设置通知提示
        let date = new Date()
        let time = date.getHours()  //  获取当前时间 24小时
        this.settingTime = res.data.result.items.filter(item => { return item.userId === this.user.id })
        if (this.settingTime.length !== 0) {
          let start = parseInt(this.settingTime[0].settingValue)
          let end = parseInt(this.settingTime[1].settingValue)
          this.isNotice = true
          // 小时数相等 比较 分钟数
          if (time === start){
            let currentMinute = date.getMinutes()  //  获取当前分钟数
            let minute = parseInt(this.settingTime[0].settingValue.slice(1, 2))
            if (minute <= currentMinute) {
              this.showNotice(this.noticeList[0])
            }
          } else if (time > start && time < end){
            this.showNotice(this.noticeList[0])
          }
        }
      })
    },
    showNotice(notice) {
      this.noticeDetail = notice
      this.noticeVisible = true
    },
    naviMore(){
      window.location.href = `#/helpCenter/helpPage?type=${this.type}`
    },
    remindNotice() {
      if (this.noticeTime[0] === '') {
        this.$Message.error('请选择时间！')
      } else {
        // 设置开始时间
        ajax.post('/api/services/app/AbpUserSettings/CreateOrUpdate',{
          abpUserSettings: {
            userId: this.user.id,
            settingName: "start",
            settingType: "noticeTime",
            settingValue: this.noticeTime[0]
          }
        }).then(() => {
          // 设置结束时间
          ajax.post('/api/services/app/AbpUserSettings/CreateOrUpdate',{
            abpUserSettings: {
              userId: this.user.id,
              settingName: "end",
              settingType: "noticeTime",
              settingValue: this.noticeTime[1]
            }
          }).then(() => {
            this.noticeModal = false
            this.$Message.success('设置成功')
            this.getSettingTime()
          })
        })
      }
    }
  },
  filters: {
    filterTime(val) {
      if (!val) {
        return ''
      }
      return val.split(' ')[0]
    }
  },
}
</script>

<style lang="less">
.notice-list {
  /deep/.ivu-card-head{
    padding: 8px 16px;
    p{
      height: unset;
    }
  } 
  /deep/.ivu-card-body {
      padding: 10px 16px;
  }
  .search{
    float: right;
  }
  .notice-item {
    position: relative;
    border-bottom: 1px solid #eee;
    // padding-bottom: 10px;
    .title, .remark, .date {
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .header {
      font-weight: 600;
    }
    .title {
      width: 80%;
    }
    .date {
      width: 20%;
    }
  }
  .detail-item {
    padding-top: 10px;
  }
  .detail-item:hover {
    background-color: rgba(92, 173, 255, 0.1);
    cursor: pointer;
  }
}
.notice-modal {
  .ivu-modal {
    top: 20px;
    height: 95%;
    .ivu-modal-content {
      height: 100%;
    }
    .ivu-modal-body {
      padding: 0;
      height: 88%;
      border-radius: 6px;
      overflow: hidden;
    }
  }
  h3 .ivu-icon {
    cursor: pointer;
    color: #aaa;
  }
}
.pending-items {
  .item {
    line-height: 50px;
    .role {
      position: absolute;
      line-height: 34px;
      padding: 8px 16px 0 8px;
      i {
        font-style: normal;
        padding: 0 6px;
        &:first-child {
          padding-left: 0;
        }
      }
      i + i {
        border-left: 1px solid #ccc;
      }
    }
  }
  .item + .item {
    border-top: 1px solid #ddd;
  }
  /deep/ .badge {
    box-shadow: none;
    right: -8px !important;
  }
  /deep/ button {
    float: right;
  }
}

</style>
